export default function isoDateToDate(isoDate) {
    return new Date(isoDate + 'T00:00:00.000');
}
